<template>
  <div v-show='data.hidden === false' class="col-sm-6 h-col-inputBoxSub">
    <div class='h-subscriber-inputLit' v-if="data.showName !== ''">
      {{data.showName}}
    </div>
    <div>
      <ejs-multiselect :fields='fields' mode='CheckBox' :enableSelectionOrder='false' :showSelectAll='false' :dataSource='data.options' :enabled='disabledReadonly' :name='data.name' :ref="data.name" ></ejs-multiselect>
<!--      <ejs-multiselect :fields='fields' :dataSource='data.options' :enabled='disabledReadonly' :name='data.name' :value='data.value' v-model='params.paramVal' :ref="data.name"></ejs-multiselect>-->
    </div>
    <!--<button @click="getParams">GetParam</button>-->
  </div>
</template>

<script>
import common from '../common';
import { CheckBoxSelection } from '@syncfusion/ej2-vue-dropdowns';

export default {
  name: 'Son_SelectCheck',
  props: [
    'data',
    'opCode'
  ],
  mixins: [common],
  provide: {
    multiselect: [CheckBoxSelection]
  },
  computed: {
    disabledReadonly() {
      return (this.data.readonly || this.data.disabled) === true ? false : true;
    }
  },
  data() {
    return {
      fields: { text: 'showName', value: 'value' },
    };
  }
};
</script>

<style scoped>

</style>
